import StatsTemplate from "./StatsTemplate";

export default function StatsGroups() {
  return <StatsTemplate entityLabel="Groups" entityType="groups" />;
}